/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import React from 'react';

import BaseSeo from '@salesforce/retail-react-app/app/components/seo';

import {jsxParser} from '@amblique/base/app/helpers/jsx-parser';
import {useSitePreference} from '@amblique/base/app/hooks/use-site-preference';

/**
 * @override
 *  - Inject `htmlHead`
 *
 * @param {object} args
 * @param {any}    args.children
 *
 * @returns {React.ReactElement}
 */
const Seo = ({children, ...props}) => {
  const htmlHead = useSitePreference('htmlHead');

  return (
    <BaseSeo {...props}>
      {children}

      {htmlHead && jsxParser.parse(htmlHead)}
    </BaseSeo>
  );
};

Seo.propTypes = BaseSeo.propTypes;

export default Seo;
